import { getInitialApi } from "./cip30.utils";
import { Cip30ConnectedWallet } from "./Cip30ConnectedWallet";
export const getCip30Wallet = (walletId) => {
    const initialApi = getInitialApi(walletId);
    if (!initialApi)
        return;
    const { icon, name } = initialApi;
    let connectedApi;
    let connectedWallet;
    return {
        icon,
        name,
        async enable() {
            if (!connectedApi) {
                connectedApi = await initialApi.enable();
                connectedWallet = new Cip30ConnectedWallet(connectedApi);
            }
            return connectedWallet;
        },
        async isEnabled() {
            return Boolean(connectedApi && connectedWallet);
        },
    };
};
//# sourceMappingURL=cip30-wallet.js.map